(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .constant('memberIntegrationResolver', {
            individualId: getIndividualId,
            integrations: getIntegrations,
            sources: getSources
        });

    getIndividualId.$inject = ['$transition$'];
    function getIndividualId($transition$) {
        return $transition$.params().individualId;
    }

    getIntegrations.$inject = ['Member', '$transition$'];
    function getIntegrations(Member, $transition$) {
        var params = $transition$.params(),
            individualId = params.individualId;
        return Member.getIntegrations({ id: individualId }, true).$promise;
    }

    getSources.$inject = ['Source'];
    function getSources(Source) {
        return Source.getAll(true).$promise;
    }
})();